<template>
  <b-modal
    :title="`Finalizar Expediente ${processedFile.numero}`"
    v-model="showModal"
    hide-footer
    centered
  >
    <div>
      Al dar por finalizado este documento, no podrás actuar sobre él, ¿estás de acuerdo?
    </div>
    <div class="chip-custom">
      ¡Al realizar esta acción se marcará
      como finalizado el expediente para todos los participantes
       y no se podrán hacer mas acciones sobre éste!
    </div>
    <div class="wrap-commentary">
      <vs-textarea
        data-cy="write-comment"
        maxlength="255"
        label="Comentario"
        v-model="comment"
      />
      <div v-if="notValid">
        <small style="color: red;">
          No has ingresado un comentario para validar esta acción
        </small>
      </div>
    </div>
    <div class="m-top-20" style="display: flex;justify-content: flex-end;">
      <vs-button
      data-cy="Cancel"
      color="dark" v-on:click="cancelProcess()"
      type="border">Cancelar</vs-button>
      <vs-button
        data-cy="yes-finish"
        v-on:click="processFile()"
        color="primary"
        style="margin-left: 12px;"
        type="border"
      >
        Si, finalizar
      </vs-button>
    </div>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import { fetchColumns } from '@/febos/global/kanban/store/actions';

export default {
  name: 'PopUpProcessFile',
  data() {
    return {
      comment: '',
      notValid: false
    };
  },
  props: {
    processedFile: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  watch: {
    comment() {
      this.notValid = false;
    },
    processedFile() {
      this.notValid = false;
      this.comment = '';
    }
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    showModal: {
      get() {
        return this.modalName === 'processFile';
      },
      set() {
        this.closeModal();
      }
    },
    isAguasAndinas() {
      return this.company.iut === '61808000-5';
    },
  },
  methods: {
    ...mapActions('Dnts', [
      'processDntFileED'
    ]),
    ...mapActions('Modals', [
      'closeModal',
      'showModals'
    ]),
    ...mapActions('kanban', {
      fetchColumns: fetchColumns.name
    }),
    async processFile() {
      this.notValid = false;
      if (this.comment === '') {
        this.notValid = true;
        return;
      }
      const toProcess = {
        febosId: this.processedFile.febosId,
        estadoId: 9,
        transportePuertoTipo: 0,
        comentario: this.comment
      };
      await this.processDntFileED(toProcess);
      if (this.isAguasAndinas) {
        this.fetchColumns();
        await this.createKanbanTask();
      }
    },
    createKanbanTask() {
      this.showModals('kanbanTask');
    },
    cancelProcess() {
      this.notValid = false;
      this.closeModal();
    }
  }
};
</script>
<style scoped>
.chip-custom {
  font-size: 12px;
  margin-top: 10px;
  color: #ffb300;
  background: #fff5df;
  border-radius: 10px;
  padding: 4px 8px;
}
.wrap-commentary {
  width: 90%;
  margin: 20px auto;
}
</style>
